<div class="purchase-order-shipments-form">
  <div
    class="overlay"
    lumAppLoader
    [loading]="loadingCurrentShipment$ | async"
    [classes]="'loading'"
  ></div>
  <h2 mat-dialog-title>
    {{ title }}
    <button
      mat-icon-button
      aria-label="Close dialog"
      class="close-button"
      (click)="onClose()"
    >
      <mat-icon>{{ headerIcon }}</mat-icon>
    </button>
  </h2>

  <mat-dialog-content>
    <form [formGroup]="form">
      <div class="flex gap-4">
        <div class="form-group w-p50">
          <label class="lum-label">Reference #</label>
          <div>
            <input
              *ngIf="mode === 'create'; else referenceNumber"
              type="text"
              class="lum-input"
              formControlName="referenceNumber"
            />
            <ng-template #referenceNumber>
              <div>
                <b>{{ (currentShipment$ | async)?.referenceNumber }}</b>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="flex gap-4">
        <div class="form-group w-p50">
          <label class="lum-label">Status</label>
          <mat-select class="lum-select" formControlName="shipmentStatusId">
            <mat-option
              *ngFor="let status of shipmentStatus$ | async; trackBy: trackById"
              [value]="status?.id"
              >{{ status?.name }}</mat-option
            >
          </mat-select>
        </div>
        <div class="form-group w-p50">
          <label for="name">Shipment Date</label>
          <input type="date" formControlName="shippingDate" class="lum-input" />
        </div>
      </div>

      <div
        class="flex gap-4"
        *ngIf="'UTAH-248-recount_incoming_with_shipments' | featureFlag"
      >
        <div class="form-group w-p50">
          <label class="lum-label">Warehouse</label>
          <mat-select class="lum-select" formControlName="warehouseId">
            <mat-option [value]="">- None (Use PO Warehouse) -</mat-option>
            <mat-option
              *ngFor="let w of warehouses; trackBy: trackById"
              [value]="w.id"
            >
              {{ w.location_name }}
            </mat-option>
          </mat-select>
        </div>
      </div>

      <hr class="mt-8" />
      <div class="purchase-order-shipment-form--items mt-8">
        <h5>Items</h5>
        <div *ngIf="mode !== 'view'">
          <label class="lum-label">Search PO #</label>
          <lum-ui-autocomplete-chip
            [debounceTime]="500"
            [options]="purchaseOrders$ | async"
            [loading]="loadingPurchaseOrders$ | async"
            [displayProperty]="'id'"
            [formArray]="selectedPurchaseOrdersFormArray"
            [selectedOptions]="selectedPurchaseOrdersFormArray.value"
            (inputChangeEvent)="onSearchPurchaseOrders($event)"
            (optionSelectedEvent)="onSelectPurhaseOrder($event)"
            (optionRemove)="onRemovePurchaseOrder($event)"
          ></lum-ui-autocomplete-chip>
        </div>
        <div class="purchase-order-shipments-table mt-4">
          <table
            *ngIf="itemsFormArray.controls?.length; else empty"
            class="lum-table lum-table--classic striped"
          >
            <thead>
              <tr>
                <th *ngIf="mode !== 'view'">
                  <mat-checkbox
                    (change)="onCheckAllItems($event)"
                    [checked]="isItemsCheckedAll"
                    color="primary"
                  ></mat-checkbox>
                </th>
                <th>PO #</th>
                <th>SKU</th>
                <th>Product Name</th>
                <th>Quantity</th>
                <th>Unit</th>
              </tr>
            </thead>
            <tbody formArrayName="shipmentItems">
              <ng-container
                *ngFor="
                  let item of itemsFormArray.controls;
                  let i = index;
                  trackBy: trackByControlValue
                "
              >
                <tr [formGroupName]="i">
                  <td *ngIf="mode !== 'view'">
                    <mat-checkbox
                      formControlName="checked"
                      color="primary"
                    ></mat-checkbox>
                  </td>
                  <td>{{ item.value?.supplierPurchaseOrderId }}</td>
                  <td>{{ item.value?.sku }}</td>
                  <td>{{ item.value?.productName }}</td>
                  <td>
                    <input
                      type="number"
                      class="lum-input text-right"
                      formControlName="quantity"
                      lumDecimalLimit
                    />
                  </td>
                  <td>
                    <mat-select
                      formControlName="unitOfMeasureId"
                      class="lum-select w-35"
                    >
                      <mat-option
                        *ngFor="
                          let option of item.value?.unitOfMeasures;
                          trackBy: trackById
                        "
                        [value]="option?.id"
                        >{{ option?.name }}</mat-option
                      >
                    </mat-select>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>

      <hr class="mt-8" />
      <div class="purchase-order-shipment-form--extra-costs mt-8">
        <h5>Extra Costs</h5>
        <lum-purchase-order-shipment-extra-cost-table
          [parentForm]="form"
          [mode]="mode"
          [itemProductCategories]="itemProductCategories"
        ></lum-purchase-order-shipment-extra-cost-table>
      </div>
    </form>
  </mat-dialog-content>

  <div *ngIf="mode !== 'view'" class="flex gap-4 justify-content-end mt-8">
    <button
      type="button"
      class="lum-button lum-button--tertiary mr-2"
      mat-button
      mat-dialog-close
    >
      Cancel
    </button>
    <lum-ui-button
      [disabled]="
        (submitting$ | async) || form.invalid || !hasAtLeastOneItemChecked
      "
      [loading]="submitting$ | async"
      (clickEvent)="onSubmit()"
    >
      Save
    </lum-ui-button>
  </div>
</div>

<ng-template #empty>
  <lum-ui-empty-page title="There are no data to display."></lum-ui-empty-page>
</ng-template>
